import React, { useState } from 'react'
import { useQuery } from 'react-query'
import { Channel } from 'twilio-chat'
import clsx from 'clsx'

import chatService from '../services/chatService'
import ActiveChat from '../components/Chat/ActiveChat'
import MessageForm from '../components/Chat/MessageForm'

const Chat: React.FC = () => {
  const [activeChannel, setActiveChannel] = useState<Channel>()
  const channels = useQuery(['chat-channels'], chatService.getChannels)

  const Channels = () => {
    if (channels.isLoading) {
      return (
        <div>
          <div className="flex animate-pulse cursor-pointer items-center px-3 py-2 text-sm">
            <div className="inline h-10 w-10 rounded-full bg-gray-100" />
            <div className="ml-3 w-full">
              <div className="flex-1 justify-between">
                <div className="mb-2 h-3 w-1/3 rounded bg-gray-100" />

                <div className="h-2 w-1/2 rounded bg-gray-100" />
              </div>
            </div>
          </div>
          <div className="flex animate-pulse cursor-pointer items-center px-3 py-2 text-sm">
            <div className="inline h-10 w-10 rounded-full bg-gray-100" />
            <div className="ml-3 w-full">
              <div className="flex-1 justify-between">
                <div className="mb-2 h-3 w-1/3 rounded bg-gray-100" />

                <div className="h-2 w-1/2 rounded bg-gray-100" />
              </div>
            </div>
          </div>
        </div>
      )
    }
    return (
      <li>
        {channels.data?.map((channel) => (
          <span
            key={channel.sid}
            className={clsx(
              'flex cursor-pointer items-center border-b border-gray-300 px-3 py-2 text-sm transition duration-150 ease-in-out focus:outline-none',
              {
                'bg-brand-50 text-brand-800': activeChannel?.sid === channel.sid,
                'text-gray-600 hover:bg-gray-100': activeChannel?.sid !== channel.sid,
              }
            )}
            onClick={async () => {
              const activeChannel = channel as unknown as Channel
              setActiveChannel(activeChannel)
            }}
          >
            {channel.attributes.endUser.profilePicture ? (
              <img
                className="h-10 w-10 rounded-full object-cover"
                src={channel.attributes.endUser.profilePicture?.url}
                alt={channel.attributes.endUser.profilePicture?.altText}
              />
            ) : (
              <div className="inline h-10 w-10 rounded-full bg-gray-300" />
            )}
            <div className="w-full pb-2">
              <div className="flex justify-between">
                <span className="ml-2 block font-semibold">{channel.attributes.endUser.displayName}</span>
                <span className="ml-2 block text-sm">{channel.dateUpdated.toLocaleDateString('en-GB')}</span>
              </div>
              <span className="ml-2 block text-sm">{channel.friendlyName}</span>
            </div>
          </span>
        ))}
      </li>
    )
  }
  return (
    <div className="gap-4 lg:grid lg:grid-cols-3">
      <div className="mb-3 bg-white shadow sm:rounded-lg lg:col-span-1 lg:mb-0">
        <ul className="overflow-auto lg:h-[32rem]">
          <h2 className="border-b border-b-gray-200 p-6 text-lg font-medium leading-6 text-gray-900">Conversations</h2>
          <Channels />
        </ul>
      </div>
      <div className="block lg:col-span-2">
        <div className="relative w-full bg-white shadow sm:rounded-lg">
          {activeChannel ? (
            <>
              <ActiveChat
                channel={activeChannel}
                // @ts-ignore
                avatar={activeChannel.attributes.endUser.profilePicture?.url}
                // @ts-ignore
                userName={activeChannel.attributes?.endUser?.displayName}
              />
              <MessageForm channel={activeChannel} />
            </>
          ) : (
            <div className="h-[40rem] w-full bg-white sm:rounded-lg" />
          )}
        </div>
      </div>
    </div>
  )
}

export default Chat
